import { SettingsPage } from "@risalabs_frontend_org/auth-wrapper";
import { Navigate } from "react-router-dom";
import ErrorPage from "../components/errorPage/errorPage";
import AsteraOncologyExternalTable from "../pages/asteraOncologyExternal/asteraOncologyExternal";
import AsteraOncologyExternalLayout from "../pages/asteraOncologyExternal/asteraOncologyExternalLayout";
import AnalyticsNew from "../pages/analyticsNew/analyticsNew";
import NycbsExternal from "../pages/nycbsExternal/nycbsExternal";
import NycbsExternalLayout from "../pages/nycbsExternal/nycbsExternalLayout";
import { OrganizationType } from "../enums/organizationTypes";
import SupportTicketLayout from "../pages/supportTickets/supportTicketLayout";

/**
 * Shared layout that provides PharmaFormFieldsContext across
 * insurance-details and pharma-pa-form routes so field values
 * persist when navigating between the two pages.
 */

export const ExternalPharmaPaRouteConfig = [
  { index: true, element: <AsteraOncologyExternalLayout /> },

  {
    path: "astera-oncology-external",
    element: <AsteraOncologyExternalLayout />,
    children: [
      { index: true, element: <Navigate to="submission-orders" replace /> },
      { path: "submission-orders", element: <AsteraOncologyExternalTable /> },
    ],
  },

  {
    path: "nycbs-external",
    element: <NycbsExternalLayout />,
    children: [
      { index: true, element: <Navigate to="sftp-file-orders" replace /> },
      {
        path: "sftp-file-orders",
        element: <NycbsExternal orgId={OrganizationType.NYCBS_PHARMA} />,
      },
      {
        path: "stat-orders",
        element: <NycbsExternal orgId={OrganizationType.NYCBS_STATS} />,
      },
    ],
  },

  {
    path: "external-analytics",
    element: <AnalyticsNew />,
  },
  {
    path: "external-support",
    element: <SupportTicketLayout />,
  },

  {
    path: "settings/*",
    element: (
      <SettingsPage
        enabledPages={[
          "profile",
          "security",
          "members",
          "support",
          "superadmin",
        ]}
        roleOptions={[
          { value: "admin_pharma", label: "Pharmacy Admin" },
          { value: "standard_pharma", label: "Standard Pharmacy" },
        ]}
      />
    ),
  },

  {
    path: "*",
    element: <ErrorPage />,
  },
];
